const PARAM_SEPARATOR = '&'
const KEY_VALUE_SEPARATOR = '='
const EMPTY_STRING = ''
const HASH = '#'
const SEARCH = '?'

export const HA_SUCCESS_KEY_NAMES = [
  'accessToken',
  'idToken',
  'state',
  'expiresIn',
  'tokenType',
] as const

export const HA_ERROR_KEY_NAMES = ['error', 'state'] as const

type SuccessKeyNamesTuple = typeof HA_SUCCESS_KEY_NAMES
type HaSuccessResultKey = SuccessKeyNamesTuple[number]
type HaSuccessResult = Record<HaSuccessResultKey, string>
type ErrorKeyNamesTuple = typeof HA_ERROR_KEY_NAMES
type HaErrorResultKey = ErrorKeyNamesTuple[number]

export function isSuccessKey(value: string): value is HaSuccessResultKey {
  return HA_SUCCESS_KEY_NAMES.includes(value as HaSuccessResultKey)
}

export function isErrorKey(value: string): value is HaErrorResultKey {
  return HA_ERROR_KEY_NAMES.includes(value as HaErrorResultKey)
}

export function toCamelCase(snailCase: string): string {
  return snailCase.replace(/[^a-zA-Z0-9]+(.)/g, (_, substring: string) => substring.toUpperCase())
}

export function toError(search: string): Record<HaErrorResultKey, string> {
  return search
    .replace(SEARCH, EMPTY_STRING)
    .split(PARAM_SEPARATOR)
    .reduce(
      (params, keyValue) => {
        const [key, value] = keyValue.split(KEY_VALUE_SEPARATOR)
        if (key && value) {
          const camelCaseKey = toCamelCase(key)
          if (isErrorKey(camelCaseKey)) {
            params[camelCaseKey] = decodeURIComponent(value)
          }
        }
        return params
      },
      { error: '', state: '' }
    )
}

export function toParams(hash: string): Record<HaSuccessResultKey, string> {
  return hash
    .replace(HASH, EMPTY_STRING)
    .split(PARAM_SEPARATOR)
    .reduce((params, keyValue) => {
      const [key, value] = keyValue.split(KEY_VALUE_SEPARATOR)
      if (key && value) {
        const camelCaseKey = toCamelCase(key)
        if (isSuccessKey(camelCaseKey)) {
          params[camelCaseKey] = decodeURIComponent(value)
        }
      }
      return params
    }, {} as HaSuccessResult)
}
